import React from 'react';

interface UserMetaFieldProp {
  label: string;
  id: string;
  handleCheckBoxFields: (e, applicant: string, fieldKey: string, index: number) => void;
  index: number;
  fieldKey: string;
  applicant: string;
}

export const UserMetaField: React.FC<UserMetaFieldProp> = ({
  applicant,
  fieldKey,
  handleCheckBoxFields,
  id,
  index = 0,
  label,
}) => {
  return (
    <div className="dental-repeater-item">
      <h6 className="field-label">{label}</h6>
      <div className="btn-group gender-input">
        <label className="btn-type-radio">
          <input
            className="btn-radio"
            data-fieldid={index}
            name={id}
            onChange={e => {
              handleCheckBoxFields(e, applicant, fieldKey, index);
            }}
            type="checkbox"
            value="1"
          />{' '}
          Yes
        </label>
      </div>
    </div>
  );
};
